import { render } from "./home13-banner.vue?vue&type=template&id=3008d65a"
import script from "./home13-banner.vue?vue&type=script&lang=js"
export * from "./home13-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__